import Vue from 'vue';
import VueI18n from 'vue-i18n';
import FlagIcon from 'vue-flag-icon';

Vue.use(FlagIcon);
Vue.use(VueI18n);

const messages = {
    'en': require('@/languages/i18n-en.json'),
    'nl': require('@/languages/i18n-nl.json')
}

const i18n = new VueI18n({
    locale: 'nl', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
});

export default i18n;
